import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import HorizontalLightLogo from "../../logos/logo-v2-light-horizontal.png";
import HorizontalDarkLogo from "../../logos/logo-v2-dark-horizontal.png";
import { useACTprepTheme } from "../../context/ACTprepContextPackage";
import { useTheme } from "@mui/material/styles";
import StyledLink from "../../components/StyledLink";
import { useParams } from "react-router-dom";

export default function ErrorPage() {
  const { theme } = useACTprepTheme();
  const muiTheme = useTheme();
  const { errorCode } = useParams();

  const ERROR_CODE_TEXT = {
    403: {
      title: "Unauthorized",
      description: "You are not allowed to access this resource",
    },
    404: {
      title: "Page not found",
      description: (
        <Typography variant="body1">
          This page does not exist.{" "}
          <StyledLink href={"/"}>Return home</StyledLink>
        </Typography>
      ),
    },
    400: {
      title: "Bad Request",
      description:
        "The request was invalid or cannot be served. Please check your input and try again.",
    },
    401: {
      title: "Unauthorized",
      description:
        "You must be authenticated to access this resource. Please log in and try again.",
    },
    500: {
      title: "Internal Server Error",
      description: "Something went wrong on our end. Please try again later.",
    },
    502: {
      title: "Bad Gateway",
      description:
        "The server received an invalid response from the upstream server.",
    },
    503: {
      title: "Service Unavailable",
      description:
        "The server is currently unavailable. Please try again later.",
    },
    504: {
      title: "Gateway Timeout",
      description:
        "The server did not receive a timely response from the upstream server.",
    },
  };

  const errorInfo = ERROR_CODE_TEXT[errorCode];
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        backgroundColor: muiTheme.palette.background.paper,
      }}
    >
      <Box
        component="img"
        sx={{
          height: 100,
          display: {
            xs: "none",
            sm: "block",
          },
          margin: "2rem",
        }}
        alt="Your logo."
        src={theme === "dark" ? HorizontalLightLogo : HorizontalDarkLogo}
      />
      <Box
        sx={{
          marginTop: "30vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            marginBottom: "2rem",
            color: muiTheme.palette.text.primary,
          }}
        >
          {errorCode} - {errorInfo.title}
        </Typography>
        <Box
          sx={{
            color: muiTheme.palette.text.primary,
          }}
        >
          {errorInfo.description}
        </Box>
      </Box>
    </Box>
  );
}
